import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const tenantAuthPolicyMenuRegistry = {
    core_tenantAuthPolicy: {
        label: "Tenant Auth Policy",
        link: PAGE_URL.TENANT_AUTH_POLICY_PAGE,
        key: PAGE_URL.TENANT_AUTH_POLICY_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default tenantAuthPolicyMenuRegistry;
